/**
 * 申請步驟內容入口
 */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import { usePersistFn } from 'ahooks';
import { securityLevel, stepInfo, StepType } from '@/utils/FosterServiceConf';
import StepContext from './StepContext';
import DataCheck from '../DataCheck';
import FormInfo from '../FormInfo';
import IdentityAuth from '../IdentityAuth';

const StepRender = (props) => {
  useContext(StepContext);
  const { currentStep, handleNext } = props;
  const context = useContext(StepContext);
  // 渲染對應步驟組件
  const renderStep = usePersistFn(() => {
    let res: React.ReactNode;
    switch (currentStep.stepType) {
      // 申請需知
      /*  case StepType.note:
        res = <AppliNote />;
        break; */
      // 申請資料：表單
      case StepType.form:
        res = <FormInfo title={currentStep.stepName} />;
        break;
      // 資料確認：數據查看
      case StepType.dataCheck:
        res = <DataCheck />;
        break;
      // 身份識別
      case StepType.faceRecognition:
       /*  res = (
          <div style={{ textAlign: 'left', padding: '40px 20px', color: '#000' }}>
            <p style={{ fontSize: '24px', margin: '10px 0' }}>生產環境進行調試中，身份識別需暫時跳過，繼續點擊下一步....</p>
          </div>
        ); */
        res = (
          <IdentityAuth
            title={currentStep.stepName}
            authLevel={securityLevel.HIGH}
            onSuccess={() => {
              if (!context.isAuth) {
                // 身份识别成功，将身份识别结果存储起来
                console.log('身份識別成功。。。。。');
                context.isAuth = true;
                handleNext();
              }
            }}
            ref={(ref) => {
              context.identityRef = ref;
            }}
          />
        );
        break;
      default:
        res = null;
    }
    return res;
  });

  return <>{renderStep()}</>;
};

export default StepRender;
